import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of phone zones based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('phone_zones', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single phone zone based on his ID
 *
 * @param id the of the phone zone requested
 */
export function getFromId(id) {
  return baseGetFromId('phone_zones', id);
}

/**
 * Get a single phone zone based on his ID
 *
 * @param id the of the phone zone requested
 */
export function getPrefixesFromId(id) {
  return baseGetFromId('phone_zones', id, 'prefix');
}

/**
 * Get a single phone zone based on his ID
 *
 * @param id the of the phone zone requested
 */
export function getPriceSourcesFromId(id) {
  return baseGetFromId('phone_zones', id, 'price_source');
}

/**
 * Get a single phone zone based on his ID
 *
 * @param id the of the phone zone requested
 */
export function getPriceDestinationsFromId(id) {
  return baseGetFromId('phone_zones', id, 'price_destination');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single phone zone based on his ID
 *
 * @param id the of the phone zone requested
 * @param data the new data of the phone zone
 */
export function editFromId(id, data) {
  return baseEditFromId('phone_zones', id, data);
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new phone zone
 *
 * @param data the new data of the phone zone
 */
export function newItem(data) {
  return baseNewItem('phone_zones', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all phone zone groups to serve in a dropdown form choice
 */
export function fetchPhoneZones() {
  return baseIndex('phone_zones', 1, 0);
}
